var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"show_language_selector":_vm.show_language_selector,"locale":_vm.locale,"homelink":""}}),_c('div',{staticClass:"mt-5 container"},[_c('Index',{attrs:{"is_guest":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }